<template> 
  <Modal closable>
      <template v-slot:header>
        <h2>{{ !signUp ? $t("auth.signin") : $t("auth.signup") }}</h2>
      </template>
      <AppLogo v-if="false" style="margin-bottom: 2rem" />
      <p v-if="!signUp">Log ind med din Google- eller Facebook-konto, for at oprette, gemme og dele ruter.</p>
      <p v-else>Opret en konto på få sekunder med din Google- eller Facebook-konto.</p>
      <AppButton class="google" @click="signInWithGoogle" fill>{{ !signUp ? $t("auth.google") : $t("auth.google_signup") }}</AppButton>
      <AppButton class="facebook" @click="signInWithFacebook" fill>{{ !signUp ? $t("auth.facebook") : $t("auth.facebook_signup") }}</AppButton>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { store } from '@/store'
import AppLogo from '@/components/atoms/AppLogo.vue'
export default defineComponent({
  name: 'SignIn',
  components: { AppLogo },
  props: {
    signUp: Boolean,
    next: Function
  },
  setup (props) {
    function signInWithGoogle() {
      store.auth.signInWithGoogle(props.next)
    }
    function signInWithFacebook() {
      store.auth.signInWithFacebook(props.next)
    }
    return { signInWithGoogle, signInWithFacebook }
  }
})
</script>

<style lang="scss">
#login {
  background: var(--color-background);
  background-image: url('../../assets/img/login_wall.svg');
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000000;

  &-box {
    background: var(--color-card-elevated);
    max-width: 30rem;
    padding: 3rem;
    border-radius: 2rem;
    box-shadow: var(--modal-shadow);
  }
}

button.google, button.facebook {
  height: 3rem !important;
  padding-left: 3.25rem !important;
  background-repeat: no-repeat !important;
  background-position: 1rem center !important;
  background-size: 1.5rem !important;
  width: 100%;
  text-align: center;
}
button.google {
    margin-bottom: .5rem;
    color: #3A526D !important;
    background-color: white !important;
    border: 1px solid var(--color-divider) !important;
    background-image: url('../../assets/icons/social-google.svg') !important;
}
button.facebook {
  background-color: #1977f3 !important;
  border: 1px solid #1977f3;
  color: white !important;
  background-image: url('../../assets/icons/social-facebook.svg') !important;
  &:hover {
    background-color: #1977f3;
    box-shadow: 0 3px 19px rgba(25, 119, 243, 0.33);
  }
}
    
</style>